// Globals
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

// Store
import { useAppDispatch } from '@/store';
import { addRequiredDocument } from '../../feature';

// Components
import { ArrowLeftIcon, PlusIcon } from '@/icons';
import { Button, EmptyDataThumbnail } from '@/ui';
import RequiredDocumentContainer from '../RequiredDocumentContainer/RequiredDocumentContainer';
import { StyledButton, StyledPage, StyledTitle, StyledWrapper } from './RequiredDocumentsContainerStyles';

// Models
import { DocumentSourceEnum } from '@/models/documents.model';
import { PropertyType } from '@/models/property.model';

// Helpers
import { useGetRequiredDocuments } from '../../hooks';
import { initialDocument } from '../../constants/common';

const RequiredDocumentsContainer = () => {
  const { t } = useTranslation(['documents', 'common']);
  const { propertyType, source } = useParams<{ propertyType: PropertyType; source: DocumentSourceEnum }>();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const { requiredDocuments } = useGetRequiredDocuments(propertyType ?? '');

  const documents = requiredDocuments.find(([property]) => source === property)?.[1];

  const handleBack = () => navigate(-1);

  const handleAddDocument = () => {
    if (!propertyType || !source) return;
    dispatch(
      addRequiredDocument({
        ...initialDocument,
        property_type: propertyType,
        source_type: source,
      }),
    );
  };

  if (!propertyType || !source || !documents) return null;

  return (
    <StyledPage>
      <StyledButton shape="round" ghost icon={<ArrowLeftIcon />} onClick={handleBack}>
        {t('button_back', {
          ns: 'common',
        })}
      </StyledButton>
      <StyledTitle>
        {t('card_title_documents', {
          context: source.toLowerCase(),
          count: documents.length,
        })}
        <Button type="primary" shape="round" onClick={handleAddDocument} icon={<PlusIcon />}>
          {t('button_add_document')}
        </Button>
      </StyledTitle>
      <StyledWrapper>
        {!documents.length && <EmptyDataThumbnail />}
        {documents.map((item) => (
          <RequiredDocumentContainer key={item?.id ?? item?.createId} document={item} propertyType={propertyType} />
        ))}
      </StyledWrapper>
    </StyledPage>
  );
};

export default RequiredDocumentsContainer;
